import {MobileBox} from '~/common/FabricInvitation/EventCreateDesign/components/Background/Mobile/Contents/MobileBox';
import {EditorContainer} from '~/common/FabricInvitation/EventCreateDesign/components/Container/Mobile/EditorContainer';
import {EditorIcons} from '~/common/FabricInvitation/EventCreateDesign/components/EditorIcons/EditorIcons';
import {useOverlay} from '~/common/OverlayAnimation/actions/useOverlay';

export const RevealEditorMobile = () => {
  const {onOverlayChange, overlayIcons, selectedOverlay} = useOverlay(false, true);

  return (
    <EditorContainer>
      <EditorContainer.Tab title="Reveals">
        <MobileBox title="Reveals">
          <EditorIcons
            className="editor-icons__reveal"
            icons={overlayIcons}
            onClick={onOverlayChange}
            highlight={false}
            selectedIcon={selectedOverlay}
            hideAnimatedIndicator
            height={58}
            width={50}
            outline
          />
        </MobileBox>
      </EditorContainer.Tab>
    </EditorContainer>
  );
};
